export const DEFAULT_COUNTRY_LANGUAGE_CODE = "USA-EN";

export const isDefaultCountryLanguageOption = (option) =>
  option?.value === DEFAULT_COUNTRY_LANGUAGE_CODE ||
  option?.combined_code === DEFAULT_COUNTRY_LANGUAGE_CODE;

export const findDefaultCountryLanguageOption = (options = []) =>
  options.find(isDefaultCountryLanguageOption) || null;

export const isDefaultCountryLanguageSection = (section, options = []) => {
  if (section?.combinedCode === DEFAULT_COUNTRY_LANGUAGE_CODE) return true;

  const defaultOption = findDefaultCountryLanguageOption(options);
  return Boolean(
    defaultOption?.id &&
      section?.country_language_id &&
      `${defaultOption.id}` === `${section.country_language_id}`,
  );
};
